import * as React from 'react';
import { WarningTwoTone } from  '@ant-design/icons';
import { Popover } from 'antd';

export const TabErrorMsg = (

):JSX.Element => {
    return (
        <div>
             <Popover content={"The operation could not be completed"} title="API Error" trigger="hover">
            <WarningTwoTone className="tab_warning_icon" twoToneColor="#e84a13"/>
            </Popover>
        </div>
    );
};
//Error message for Outstanding Accounts Card in Billing Tab 
export const BillingTabErrorMsg = (

    ):JSX.Element => {
        return (
            <div>
                 <Popover content={"The operation could not be completed"} title="API Error" trigger="hover">
                <WarningTwoTone className="billing_tab_warning_icon" twoToneColor="#e84a13"/>
                </Popover>
            </div>
        );
    };